import React from 'react'
import styled from 'styled-components'
import { padding, paddingSizes } from 'theme/default'
import Input, { InputElement, LabelElement } from './Input'

const SimpleInputElement = styled(InputElement)`
  padding-top: ${padding[paddingSizes.small]};
`

const SimpleInputLabelElement = styled(LabelElement)`
  visibility: hidden;
`

const SimpleInput = (props) => (
  <Input Element={SimpleInputElement} LabelComponent={SimpleInputLabelElement} {...props} />
)

SimpleInput.AddOn = Input.AddOn

export default SimpleInput
